import { usePromotion } from '../usePromotion'
import { parseFeatureVariables } from '../parseFeatureVariables'

export const useGiftEligiblePercentOff = () => {
  const { isPromotionOn, variables } = usePromotion()
  if (!isPromotionOn) {
    return null
  }

  let promoData = null
  try {
    promoData = parseFeatureVariables(variables)
  } catch (e) {
    reportError(e)
    return null
  }

  if (
    promoData?.gift_eligible &&
    promoData.experience === 'all_tiers_discount'
  ) {
    const percentageOff = promoData.percentage_off
    return percentageOff
  }
  return null
}
